/** @see https://stackoverflow.com/a/37511463 */
export const normaliseString = (string: string): string => {
  return removeDiacritics(string).toLowerCase().trim()
}

export const removeDiacritics = (string: string): string => {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
